import settings from "../constants/frontEndSettings.js";

const useBootstrap = () => {
  const trashold = settings.bootstrapSettings.layout.trashHold;
  const result = { trashold: trashold };

  for (let i = 1; i <= 12; i++) {
    const newObj = {};
    newObj[trashold] = i;
    result[`trashold${i}`] = newObj;
  }

  result.classes = {
    //trashold true ako ocemo apply klase preko trasholda, false ako ispod
    onOrAboveTrashold: {
      marginTop: (pTrashold, pMarigin = 3) => {
        return pTrashold === true
          ? `mt-${pMarigin} m-${trashold}-0`
          : `mt-0 m-${trashold}-${pMarigin}`;
      },
      show: (pTrashold) => {
        return pTrashold === true
          ? `d-none d-${trashold}-block`
          : `d-block d-${trashold}-none`;
      },
    },
  };

  return result;
};

export default useBootstrap;
